import { forwardRef, Ref } from 'react'
import BaseCascader, {
  CascaderProps as BaseCascaderProps,
  CascaderRef,
} from 'antd/lib/cascader'

export type CascaderProps<DataNodeType> = BaseCascaderProps<DataNodeType>

export const Cascader = forwardRef(
  (props: CascaderProps<any>, ref: Ref<CascaderRef>): JSX.Element => {
    return (
      <>
        <BaseCascader {...props} ref={ref} />
      </>
    )
  }
)
